import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { ValidationLevel, ValidationProps } from 'ui';

export const getCurrentImportCodeValidation = (
  importNumber: number,
  codetableId: number,
  codeId: number,
  externalValue: string,
  validationProps: ValidationProps): ValidationProps => {

  if (!isDefinedIncludingZero(codetableId) || !isDefinedIncludingZero(codeId)) {
    return {} as ValidationProps;
  }

  const validationMessage = validationProps?.messages
    ?.find(item =>
      item?.parameters?.codetableId === codetableId &&
      item?.parameters?.codeId === codeId &&
      item?.parameters?.value === externalValue &&
      item?.parameters?.importNumber === importNumber
    );

  return validationMessage ? {
    level: ValidationLevel.error,
    messages: [validationMessage]
  } : {} as ValidationProps;
};
